module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "flash-container"
    }
  }, _vm._l((_vm.allFlashes), function(f, index) {
    return _c('transition-group', {
      key: index,
      attrs: {
        "name": "fade"
      }
    }, [_c('div', {
      key: index,
      class: f.type + ' ls-md-margin-bottom ls-dismissable',
      attrs: {
        "id": index
      }
    }, [_c('span', {
      staticClass: "ls-dismiss",
      attrs: {
        "data-ls-module": "dismiss"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeFlash(index)
        }
      }
    }, [_vm._v("×")]), _vm._v(" "), (!(f.hideWarning === true)) ? _c('strong', [_vm._v(_vm._s(_vm.flashPrefix(f.type)))]) : _vm._e(), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(f.message)
      }
    }), _vm._v(" "), _vm._l((f.errors), function(error) {
      return _c('div', [_c('p', {
        domProps: {
          "innerHTML": _vm._s(error)
        }
      })])
    })], 2)])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6711ecd9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/shareds/flash/FlashMessage.vue
// module id = 792
// module chunks = 1